import { Route } from '@angular/router';
import { AuthenticatedUserGuard } from '../../../../../auth/routing/guards';
import { TenderSupplierInputBidComponent } from '../../../../pages';
import { SealedTenderGuard } from '../../../guards';
import {
    SupplierProposalResolver,
    SupplierResolver,
    TenderSupplierInputBidResolver
} from '../../../resolvers';


export const tenderSupplierInputBidRoute: Route = {
    path: 'supplier/:id/input-bid',
    component: TenderSupplierInputBidComponent,
    canActivate: [AuthenticatedUserGuard, SealedTenderGuard],
    resolve: {
        tender: TenderSupplierInputBidResolver,
        proposal : SupplierProposalResolver,
        supplier : SupplierResolver
    },
    loadChildren: () => import('../../../../../supplier/supplier.module').then(m => m.SupplierModule)
};
